<template>
  <div>
    <div class="buttons is-pulled-right">
      <div class="button is-secondary is-rounded" @click="add">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add") }}</span>
      </div>
    </div>
    <h5 class="title is-5 pt-3">{{ $t("users") }}</h5>
    <table class="table is-bordered is-fullwidth">
      <thead>
        <tr>
          <th>{{ $t("user") }}</th>
          <th>{{ $t("password") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rsrc, ridx) in meta.users" :key="ridx">
          <td>
            <input type="text" class="input" v-model="meta.users[ridx].user" />
          </td>
          <td>
            <input
              type="password"
              class="input"
              v-model="meta.users[ridx].password"
            />
          </td>
          <td>
            <div
              class="button is-secondary has-text-danger is-rounded"
              @click="meta.users.splice(ridx, 1)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Basic",
  data() {
    return {
      meta: { users: [] },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      let v = this;
      Object.keys(data).map((k) => {
        v.meta[k] = data[k];
      });
    },
    clear() {
      this.meta = {
        users: [],
      };
    },
    add() {
      let v = this;
      v.meta.users.push({
        user: "",
        password: "",
      });
    },
  },
};
</script>
